var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentDownloadContained(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0835 8.49175H14.6752C12.7002 8.49175 11.0918 6.88341 11.0918 4.90841V2.50008C11.0918 2.04175 10.7168 1.66675 10.2585 1.66675H6.72516C4.1585 1.66675 2.0835 3.33342 2.0835 6.30841V13.6917C2.0835 16.6667 4.1585 18.3334 6.72516 18.3334H13.2752C15.8418 18.3334 17.9168 16.6667 17.9168 13.6917V9.32508C17.9168 8.86675 17.5418 8.49175 17.0835 8.49175Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 1.84158C12.8251 1.49991 12.2334 1.73325 12.2334 2.20825V5.11658C12.2334 6.33325 13.2667 7.34158 14.5251 7.34158C15.3167 7.34991 16.4167 7.34991 17.3584 7.34991C17.8334 7.34991 18.0834 6.79158 17.7501 6.45825C16.5501 5.24991 14.4001 3.07491 13.1667 1.84158Z",
    fill: "#838B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2334 12.2667C9.9917 12.025 9.5917 12.025 9.35003 12.2667L8.75003 12.8667V9.375C8.75003 9.03333 8.4667 8.75 8.12503 8.75C7.78337 8.75 7.50003 9.03333 7.50003 9.375V12.8667L6.90003 12.2667C6.65837 12.025 6.25837 12.025 6.0167 12.2667C5.77503 12.5083 5.77503 12.9083 6.0167 13.15L7.68337 14.8167C7.6917 14.825 7.70003 14.825 7.70003 14.8333C7.75003 14.8833 7.8167 14.925 7.88337 14.9583C7.9667 14.9833 8.0417 15 8.12503 15C8.20837 15 8.28337 14.9833 8.35837 14.95C8.43337 14.9167 8.50003 14.875 8.5667 14.8167L10.2334 13.15C10.475 12.9083 10.475 12.5083 10.2334 12.2667Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDownloadContained);
export default __webpack_public_path__ + "static/media/document-download-contained.4124c29de698301f545dd20c4977f3d3.svg";
export { ForwardRef as ReactComponent };